<template>
    <div  v-if="isVerifiedUser" class="mb-3" :class="sizeClassObject">
        <div class="card h-100">
            <div class="card-header">
                <h5 class="card-title">{{$t('home.myLastActionLogs')}}</h5>
            </div>
            <div class="card-body">
                <div v-if="myActionLogs.length">
                    <ActionLogCard v-for="log in myActionLogs"
                                    :key="log.id"
                                    :log="log">
                    </ActionLogCard>
                </div>
                <div v-else>
                    <span class="text-danger">{{$t('home.noData')}}</span>
                </div>
            </div>
            <div class="card-footer">
                <router-link :to="{ path: '/logs'}" replace class="card-link">{{$t('home.showMore')}}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { Role } from '../../helpers/role';
    import bus from '../../components/sidemenu/event-bus';
    import ActionLogCard from '../../components/administration/audit/ActionLogCard'

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                myActionLogs: [],
            }
        },
        components: {
            ActionLogCard
        },
        computed: {
            isVerifiedUser() {
                return this.$store.getters.userRoles.includes(Role.VerifiedUser)
                    || this.$store.getters.userRoles.includes(Role.Participant);
            },
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.size);
            },
        },
        methods: {
            crearMyActionLogs() {
                if (this.myActionLogs.length) {
                    while (this.myActionLogs.length > 0) {
                        this.myActionLogs.pop();
                    }
                }
            },
            loadMyActionLogs() {
                this.$http
                    .get(`api/ActionLog/myLast/${5}`)
                    .then(result => {
                        this.crearMyActionLogs();

                        if (result.data.length) {
                            result.data.forEach(item => {
                                this.myActionLogs.push(item);
                            })
                        }
                    })
                    .catch(err => console.log(err));
            },
            onActionLogCreate(userId) {
                if (userId && this.currentUserId === userId) {
                    this.loadMyActionLogs();
                }
            },
        },
        created() {
            this.bus = bus;

            this.bus.$on('action-log-create', this.onActionLogCreate);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('action-log-create', this.onActionLogCreate);
        },
        mounted() {
            this.loadMyActionLogs();
        }
    }
</script>

